export default "__VITE_ASSET__HMfoWw4z__"